import { AppDefinition } from '../../types/apps';

export const TerminalAppDefinition: AppDefinition = {
  appId: 'terminal',
  name: 'Terminal',
  version: '1.0.0',
  description: 'Persistent PTY terminal sessions on your local machine. Shell state (cwd, env, activated venvs) persists across commands.',

  icon: {
    type: 'phosphor',
    phosphorIcon: 'Terminal',
    phosphorWeight: 'bold',
    color: '#10b981',
  },

  creator: {
    name: 'River',
    verified: true,
  },

  categories: ['Developer Tools'],
  tags: ['terminal', 'shell', 'pty', 'bash', 'developer'],
  releaseDate: new Date().toISOString(),
  lastUpdated: new Date().toISOString(),

  entityTypes: ['Terminal'],
  searchableSkeletonFields: {
    Terminal: ['name', 'cwd', 'shell'],
  },

  component: 'terminal',
  requiresEntity: true,
  requiresProps: false,
};
